import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'templates'
const verb = 'delete'

export default class OspreyTemplatesTagsRemove extends BaseAction {
    constructor(dataKey) {
        const id = 'f22a505e-d247-4068-a744-990e74c06c31'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    removeTagFromTemplate(params) {
        const { templateId, tagId } = params

        this.path = `/${resource}/${templateId}/tags/${tagId}`

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/templates/templates-tags-remove.js